import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { hillsboroConfig } from "./data";

export default function HillsboroPage() {
  return <CityPageTemplate config={hillsboroConfig} />;
}